import Button from '@material-ui/core/Button';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { withStyles } from '@material-ui/styles';
// import PropTypes from "prop-types";
import classnames from 'classnames';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
// TABS
import { TabBar } from '../TabBar';
import { OrderDetailCommunicationTab, OrderDetailBetterViewiFrameTab, OrderDetailVexceliFrameTab } from './orderDetailTabs';
import { OrderDetailContextProvider } from './OrderDetailContext';

// SERVICES

const styles = theme => ({
  blue: {
    backgroundColor: 'blue',
  },
});

export const ORDER_DETAIL_TAB_KEY = 'ORDER_DETAIL_TAB';
export const tabIndexes = {
  communication: 0,
  // betterViewiFrame: 1,
  vexceliFrame: 1,
};

export const ClientOrderDetail = withStyles(styles)(props => {
  const { orderLineId } = props.match.params;

  const [query] = useState(queryString.parse(props.history.location.search));
  const [activeTab, setActiveTab] = useState(0);
  const [tabsLoaded, setTabsLoaded] = useState({
    communication: false,
    // betterViewiFrame: false,
    vexceliFrame: false,
  });

  const updateLoaded = (tabKey, value) => {
    setTabsLoaded(Object.assign({}, tabsLoaded, { [tabKey]: value }));
  };

  const updateActiveTab = key => {
    localStorage.setItem(ORDER_DETAIL_TAB_KEY, key);
    const activeTabIndex = tabs.findIndex(tab => tab.key === key);
    setActiveTab(activeTabIndex);
  };

  const tabs = [
    {
      label: 'Communication',
      key: 'communication',
      component: (
        <OrderDetailCommunicationTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.communication}
          updateLoaded={val => updateLoaded('communication', val)}
          query={query}
        />
      ),
    },
    // {
    //   label: 'BetterView',
    //   key: 'betterViewiFrame',
    //   component: (
    //     <OrderDetailBetterViewiFrameTab
    //       orderLineId={orderLineId}
    //       loaded={tabsLoaded.map}
    //       updateLoaded={val => updateLoaded('betterViewiFrame', val)}
    //       query={query}
    //     />
    //   ),
    // },
    {
      label: 'Vexcel',
      key: 'vexceliFrame',
      component: (
        <OrderDetailVexceliFrameTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.map}
          updateLoaded={val => updateLoaded('vexceliFrame', val)}
          query={query}
        />
      ),
    },
  ];

  useEffect(() => {
    const lastKnownTabIndex = localStorage.getItem(ORDER_DETAIL_TAB_KEY);

    if (lastKnownTabIndex) {
      //updateActiveTab(parseInt(lastKnownTabIndex));
      setActiveTab(0);
    } else {
      setActiveTab(0);
    }

    return () => {
      localStorage.removeItem(ORDER_DETAIL_TAB_KEY);
    };
  }, []);

  return (
    <OrderDetailContextProvider>
      <div className={classnames('flex-1', 'col-center-start')}>
        {query.referrer && (
          <Button style={{ marginBottom: 10 }} onClick={() => props.history.goBack()}>
            <ChevronLeft />
            Return to {query.referrer}
          </Button>
        )}
        <TabBar tabs={tabs} changeTab={updateActiveTab} activeTab={activeTab} />


        <div
          className={classnames(
            'card',
            'my-10',
            'flex-1',
            'align-stretch',
            'border-left-green',
          )}
        >
          {tabs[activeTab].component}
        </div>
      </div>
    </OrderDetailContextProvider>
  );
});

ClientOrderDetail.propTypes = {};

ClientOrderDetail.defaultProps = {};
